import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";

const initialState: boolean = false;

export function submittingLoginReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.LOGIN:
            return !state;
        case AuthActionTypes.LOGIN_SUCCESS:
        case AuthActionTypes.LOGIN_FAIL:
            return !state;
        default:
            return state;
    }
}
